module.exports = function (form) {
    var $form = form.getFormElem();
    var mouseFlowFormId = '#' + $form[0].id;
    var formId = form.getId();    

    form.onSubmit(function (form) {
        window._mfq.push(['formSubmitAttempt', mouseFlowFormId]);
    });

    form.onValidate(function (validationStatus) {
        if (!validationStatus) {
            window._mfq.push(['formSubmitFailure', mouseFlowFormId]);
        }        
    });

    form.onSuccess(function (vals, followUpUrl) {
        window._mfq.push(['formSubmitSuccess', mouseFlowFormId]);
        
        var $formContainer = $form.closest('[data-on-success]');
        var formSuccessFunctionName = $formContainer.data('onSuccess');
        var customOnSuccess = undefined;

        if (formSuccessFunctionName) {
            var current = window.ICF;
            var formSuccessFunctionPaths = formSuccessFunctionName.split('.');

            for (var i = 0; i < formSuccessFunctionPaths.length; ++i) {
                var pathElement = formSuccessFunctionPaths[i];
                if (pathElement === 'ICF') {
                    continue;
                }

                current = current[pathElement];
            }

            var formSuccessFunction = current(form);

            customOnSuccess = formSuccessFunction(vals, $formContainer, followUpUrl);
        }

        var formName = '';
        var personalizationRuleName = '';

        window.dataLayer = window.dataLayer || [];

        if ($form.closest('.blog-subscribe-form').length) {
            dataLayer.push({
                event: 'successfulSubscription',
                formId: formId
            });
        }
        else if ($form.closest('.embedded-subscription-module').length) {
            formName = $form.closest('.embedded-subscription-module').find('h3').first().text();
            personalizationRuleName = $form.closest('.embedded-subscription-module').data('personalizationRuleName');
        }
        else if ($form.closest('.insights-detail__form').length) {
            dataLayer.push({
                'event': 'resourceRegistrationComplete',
                formId: formId
            });

            formName = 'Resource Registration';
        }
        else {
            formName = $form.closest('.marketo-form').find('h2').first().text();
            personalizationRuleName = $form.closest('.marketo-form').data('personalizationRuleName');

            dataLayer.push({
                event: 'formSubmissionSuccess',
                formName: formName,
                data: vals,
                formId: formId,
                personalizationRuleName: personalizationRuleName
            });
        }

        dataLayer.push({
            event: 'formSubmission',
            formName: formName,
            data: vals,
            formId: formId,
            personalizationRuleName: personalizationRuleName
        });

        var mediaId = ICF.Utils.GetUrlParameter('mediaId');
        var gatingFormId = ICF.Utils.GetUrlParameter('gatingFormId');

        if (mediaId && gatingFormId) {
            $.post('/icfapi/gating/registercompletion?mediaId=' + mediaId + '&gatingFormId=' + gatingFormId, function () {
                var newUrl = followUpUrl + (followUpUrl.indexOf('?') === -1 ? '?' : '&') + 'mediaId=' + mediaId;
                window.location = newUrl;
            });

            return false;
        }
        else if ($form.closest('.insights-detail__form').length && window.videoId) {
            $.post('/icfapi/analytics/trackgoal?goalId={6F630192-7305-4076-BFEF-AB1BFC947D1B}');

            var newUrl = window.location.href +
                (window.location.href.indexOf('?') === -1 ? '?' : '&') +
                'success=true&video=' +
                window.videoId;

            window.location.href = newUrl;

            return false;
        } else if ($form.closest('.insights-detail__form').length && window.resourceMediaId) {
            if (followUpUrl && followUpUrl.length) {
                var newFollowUpUrl = URI(followUpUrl);
                newFollowUpUrl.setQuery('mediaId', window.resourceMediaId);

                if (window.sourcePageId) {
                    newFollowUpUrl.setQuery('sourcePageId', window.sourcePageId);
                }

                window.location.href = newFollowUpUrl;
            } else {
                $form.html('<h2>Register to Download</h2><p class="marketo-form-success-text">Thank you for downloading! Your copy will download automatically. We have also emailed you the download link.<br/><br/>If your download did not start automatically, <a target="_blank" href="' + window.resourceDownloadUrl + '">click here to download</a>.</p>');

                var isIE = /*@cc_on!@*/false || !!document.documentMode;
                var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                if (isIE) {
                    var downloadCallback = function () {
                        var blobObject = this.response;
                        window.navigator.msSaveBlob(blobObject, window.resourceFileName);
                    };

                    var a = new XMLHttpRequest();
                    a.addEventListener('load', downloadCallback, false);
                    a.open('get', window.resourceDownloadUrl, true);
                    a.responseType = 'blob';
                    a.send();
                }
                else if (isIOS) {
                    window.location.href = window.resourceDownloadUrl;
                }
                else {
                    document.getElementById('resourceDownloadLink').click();
                }

                $("body").css("cursor", "");
            }

            return false;
        }
        else if ($form.closest('.insights-detail__form').length && window.gatedRedirect) {
            if (window.gatedRedirect[0] == '/') {                
                var redirectUrl = URI(URI(window.location.href).origin() + window.gatedRedirect);
                window.location.href = redirectUrl;
            }
            else {
                window.location.href = window.gatedRedirect;
            }
            
            return false;
        }

        if (customOnSuccess !== undefined && !customOnSuccess) {
            return false;
        }

        if (window.sourcePageId) {
            var newFollowUpUrl = URI(followUpUrl);
            newFollowUpUrl.setQuery('sourcePageId', window.sourcePageId);
            window.location.href = newFollowUpUrl;
            return false;
        }        
    });
}